import React, { lazy, Suspense } from 'react';
const P5FullscreenWrapper = lazy(() => import('./P5FullscreenWrapper'));

export function LazyP5Sketch(actualSketch) {
  return (
    <Suspense fallback={<div />}>
      <P5FullscreenWrapper sketch={actualSketch} />
    </Suspense>
  );
}
